module.exports = __webpack_public_path__ + "img/thumbnail_Nilgai_j_melanistic.67b7cfdd.png";